var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSiteSurveyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.00390625,
    width: 60,
    height: 60,
    rx: 4,
    fill: "#CCD5DE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.7865 37.7427H28.2056V31.8177C28.2056 31.4218 28.4709 31.1747 28.859 31.1747H32.141C32.537 31.1747 32.7865 31.4218 32.7865 31.8177V37.7427ZM22.6782 37.1273C22.6782 38.3056 23.3959 39.0009 24.601 39.0009H36.4211C37.6262 39.0009 38.3438 38.3056 38.3438 37.1273V29.8097L31.0526 23.7552C30.7008 23.4511 30.3028 23.4625 29.9623 23.7552L22.6782 29.8027V37.1273ZM20 29.1393C20 29.4599 20.257 29.7614 20.6823 29.7614C20.9007 29.7614 21.0769 29.645 21.2365 29.5138L30.1732 22.0768C30.3887 21.8972 30.6279 21.891 30.8489 22.0768L39.7713 29.5138C39.9388 29.645 40.115 29.7614 40.3334 29.7614C40.7071 29.7614 41 29.5302 41 29.1628C41 28.9238 40.9263 28.7657 40.7481 28.6196L31.5359 20.9424C30.9018 20.4098 30.1352 20.4098 29.494 20.9424L20.2597 28.6196C20.0816 28.7657 20 28.9551 20 29.1393ZM36.2581 25.3824L38.3438 27.1233V23.0308C38.3438 22.6779 38.1042 22.4518 37.7558 22.4518H36.8584C36.5056 22.4518 36.2581 22.6779 36.2581 23.0308V25.3824Z",
    fill: "#1F2647"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiteSurveyIcon);
export default __webpack_public_path__ + "static/media/site-survey-icon.1e09d27a066aa16cefdff1842ef3ce70.svg";
export { ForwardRef as ReactComponent };